module.exports = __webpack_public_path__ + "static/media/instant_auto_cash.ff8222ff.png";